import React from 'react'

const Microsoft = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.98638 0.833008H0.512695V10.3067H9.98638V0.833008Z"
      fill="#F25022"
    />
    <path
      d="M9.98638 11.3594H0.512695V20.8331H9.98638V11.3594Z"
      fill="#00A4EF"
    />
    <path
      d="M20.5127 0.833008H11.0391V10.3067H20.5127V0.833008Z"
      fill="#7FBA00"
    />
    <path
      d="M20.5127 11.3594H11.0391V20.8331H20.5127V11.3594Z"
      fill="#FFB900"
    />
  </svg>
))
Microsoft.displayName = 'Microsoft'

export { Microsoft }
